interface MetaTag {
  name: string
  content: string
}

interface HeadConfig {
  title: string
  meta: MetaTag[]
}

interface PrivacyPolicyConfig {
  head: HeadConfig
  lastUpdated: string
  version: number
}

export const privacyPolicyConfig: PrivacyPolicyConfig = {
  head: {
    title: 'Privacy Policy | Gousto | Recipe Boxes',
    meta: [
      {
        name: 'description',
        content:
          "Read Gousto's comprehensive Privacy Policy covering data collection, usage, and your rights.",
      },
      {
        name: 'keywords',
        content:
          'Gousto, recipe delivery, ingredients, fresh, healthy food, cooking, privacy policy, data protection',
      },
    ],
  },
  lastUpdated: '07/02/24',
  version: 3,
}
